export const bigBrainTrack = (name, data) => {
  if (!window.bigBrainTrack) return;

  window.bigBrainTrack(name, data);
};
